import React, { useMemo } from "react";
import { BedIcon, DrinkGlassIcon, GlassIcon, ParkIcon, ServiceIcon, WiFiIcon } from "../../../helper/HwIcon";

function extractCheckInOutTimes(htmlString) {
  const text = htmlString?.replace(/<[^>]*>/g, ' ')?.replace(/\s+/g, ' ');

  let checkIn = null;
  let checkOut = null;
  const checkInPatterns = [
    /check.in.*?(\d{1,2}:\d{2}\s?(?:AM|PM|am|pm)?)/i,
    /check-in.*?(\d{1,2}:\d{2}\s?(?:AM|PM|am|pm)?)/i,
    /check-in time starts at\s*(\d{1,2}:\d{2}\s?(?:AM|PM))/i,
    /check-in hour\s*(\d{1,2}:\d{2}.*\d{1,2}:\d{2})/i,
    /check-in\s*[:\-]\s*(\d{1,2}:\d{2}\s?(?:AM|PM|am|pm)?)/i,
  ];

  const checkOutPatterns = [
    /check.out.*?(\d{1,2}:\d{2}\s?(?:AM|PM|am|pm)?)/i,
    /check-out time is\s*(\d{1,2}:\d{2}\s?(?:AM|PM))/i,
    /check-out hour\s*(\d{1,2}:\d{2})/i,
  ];

  for (const pattern of checkInPatterns) {
    const match = text?.match(pattern);
    if (match) {
      checkIn = match[1]?.trim();
      break;
    }
  }

  for (const pattern of checkOutPatterns) {
    const match = text?.match(pattern);
    if (match) {
      checkOut = match[1]?.trim();
      break;
    }
  }
  return { checkIn, checkOut };
}

export const useHotelUtils = (hotel,remark) => {
  let images = [];
  let checkIn='';
  let facilitiesPopular = []
  let checkout = '';
  if (hotel?.images) {
    try {
      const parsedImages = hotel?.images && hotel?.images !== "null" && hotel?.images !== "[null]"
        ? JSON.parse(hotel?.images)
        : [];
      if (Array.isArray(parsedImages)) {
        images = parsedImages.filter(Boolean);
      }
    } catch (error) { }
  }
  if (hotel?.details?.images?.length) {
    const detailImgs = hotel?.details?.images?.map((img) => img?.fastlyUrl)
      .filter(Boolean);
    images = [...images, ...detailImgs];
  }

  if(hotel?.vendor === 'HOTELRACK'){
    const { checkIn: checkInTime, checkOut: checkoutTime } = extractCheckInOutTimes(remark);
    checkIn = checkInTime || hotel?.details?.guestPolicies?.find((policy) => policy?.label === 'Check-in')?.description ||  "1 PM";
    checkout = checkoutTime || hotel?.details?.guestPolicies?.find((policy) => policy?.label === 'Check-out')?.description || "11 AM";
  } else {
    if(hotel?.details?.guestPolicies?.length){
      checkIn = hotel?.details?.guestPolicies?.find((policy) => policy?.label === 'Check-in')?.description
      checkout = hotel?.details?.guestPolicies?.find((policy) => policy?.label === 'Check-out')?.description
    }
  }

  if(hotel?.details?.amenities?.length){
    facilitiesPopular = hotel?.details?.amenities?.map((a) => {
      if(a?.name?.toLowerCase()?.includes('rest') || a?.name?.toLowerCase()?.includes('meal')){
        return {icon: <GlassIcon/>, label: a?.name}
      }else if(a?.name?.toLowerCase()?.includes('internet')){
        return {icon: <WiFiIcon/>, label: a?.name}
      }else if(a?.name?.toLowerCase()?.includes('park')){
        return {icon: <ParkIcon/>, label: a?.name}
      }else if(a?.name?.toLowerCase()?.includes('room') || a?.name?.toLowerCase()?.includes('bed')){
        return {icon: <BedIcon/>, label: a?.name}
      }else if(a?.name?.toLowerCase()?.includes('break')){
        return {icon: <DrinkGlassIcon/>, label: a?.name}
      }
      return {icon: <ServiceIcon/>, label: a?.name}
    })
  }
  const ratings = useMemo(() => {
    const _ratings = parseInt(hotel?.rating || "1", 10);
    return Array(typeof _ratings === "number" ? _ratings : 0).fill(
      Math.random()
    );
  }, [hotel?.rating]);

  const scrollToDiv = (id) => {
    const elem = document.getElementById(id);
    if (!elem) return;
    elem.style.scrollMarginTop = "150px";
    elem.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return { ratings, images, scrollToDiv , checkIn , checkout, facilitiesPopular};
};
